import { Component, Input } from '@angular/core';
import { TableColumns } from '@smartera/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
	// host element = <tr>
	selector: 'tr[tableDataLoadingRow]',
	imports: [Skeleton],
	template: `
		@for (col of columns; track col.field) {
			<td>
				<p-skeleton height="1.5rem"></p-skeleton>
			</td>
		}
		@if (showActionColumn) {
			<td>
				<p-skeleton height="1.5rem"></p-skeleton>
			</td>
		}
		@if (showPreActionColumn) {
			<td>
				<p-skeleton height="1.5rem"></p-skeleton>
			</td>
		}
	`,
})
export class TableDataLoadingRowComponent {
	@Input() columns: TableColumns<never> = [];
	@Input() showActionColumn = false;
	@Input() showPreActionColumn = false;
}
